import React, { useEffect, useState } from 'react';

export type ToastType = 'success' | 'danger' | 'info' | 'primary' | 'warning';

interface CustomSnackbarProps {
  message: string;
  type?: ToastType;
  show: boolean;
  onClose: () => void;
  duration?: number; // in milliseconds
}

const CustomSnackbar: React.FC<CustomSnackbarProps> = ({
  message,
  type = 'primary',
  show,
  onClose,
  duration = 3000,
}) => {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    if (show) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  if (!visible) return null;

  return (
    <div
      className={`position-fixed bottom-0 end-0 p-3`}
      style={{ zIndex: 9999 }}
    >
      <div
        className={`toast d-flex align-items-center text-white bg-${type} border-0 show`}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{ minWidth: '250px' }}
      >
        <div className="toast-body">{message}</div>
        <button
          type="button"
          className="btn-close btn-close-white me-2 m-auto"
          aria-label="Close"
          onClick={() => {
            setVisible(false);
            onClose();
          }}
        ></button>
      </div>
    </div>
  );
};

export default CustomSnackbar;
